import React from 'react';

import type { NavigationBarSliceProps } from '@ww-digital/web-palette-react/dist/components/Slice/NavigationBarSlice/NavigationBarSlice';

import { NavigationBarSlice } from '@ww-digital/web-palette-react/dist/components/Slice/NavigationBarSlice/NavigationBarSlice';

interface NavigationBarSliceContainerProps {
  slice: NavigationBarSliceProps;
}

export const NavigationBarSliceContainer = ({
  slice,
}: NavigationBarSliceContainerProps): JSX.Element => {
  return <NavigationBarSlice {...slice} />;
};
